// Configuration for color pickers
export const getColorConfigs = (t: (key: string) => string) =>
  [
    {
      key: 'mainColor' as const,
      label: t('branding.fields.main_color'),
      tooltip: t('branding.tooltips.main_color'),
    },
    {
      key: 'headerColor' as const,
      label: t('branding.fields.header_color'),
      tooltip: t('branding.tooltips.header_color'),
    },
    {
      key: 'footerColor' as const,
      label: t('branding.fields.footer_color'),
      tooltip: t('branding.tooltips.footer_color'),
    },
    {
      key: 'secondaryColor' as const,
      label: t('branding.fields.secondary_color'),
      tooltip: t('branding.tooltips.secondary_color'),
    },
    {
      key: 'infoBoxColor' as const,
      label: t('branding.fields.info_box_color'),
      tooltip: t('branding.tooltips.info_box_color'),
    },
    {
      key: 'tableHeaderColor' as const,
      label: t('branding.fields.table_header_color'),
      tooltip: t('branding.tooltips.table_header_color'),
    },
  ] as const;

// Helper function to validate hex color
export const isValidHexColor = (color: string): boolean => {
  const hexRegex = /^#[0-9A-Fa-f]{6}$/;
  return hexRegex.test(color);
};

// Helper function to format color input
export const formatColorInput = (input: string): string => {
  // Remove any non-hex characters and limit to 7 characters (#RRGGBB)
  let formatted = input.replace(/[^#0-9A-Fa-f]/g, '');

  // Ensure it starts with #
  if (!formatted.startsWith('#')) {
    formatted = '#' + formatted.replace('#', '');
  }

  // Limit to 7 characters
  return formatted.substring(0, 7).toUpperCase();
};

